import { create } from 'zustand';
import type { UploadedFile } from '@/types/message.types';

interface MediaMessageCarouselState {
  isOpen: boolean;
  files: UploadedFile[];
  currentIndex: number;
  actions: {
    openCarousel: (files: UploadedFile[], index?: number) => void;
    closeCarousel: () => void;
    setCurrentIndex: (index: number) => void;
    nextSlide: () => void;
    prevSlide: () => void;
  };
}

export const useMediaMessageCarousel = create<MediaMessageCarouselState>(
  (set, get) => ({
    isOpen: false,
    files: [],
    currentIndex: 0,

    actions: {
      openCarousel: (files: UploadedFile[], index = 0) =>
        set({
          isOpen: true,
          files,
          currentIndex: index,
        }),

      closeCarousel: () =>
        set({
          isOpen: false,
          files: [],
          currentIndex: 0,
        }),

      setCurrentIndex: (index: number) =>
        set({
          currentIndex: Math.max(0, Math.min(index, get().files.length - 1)),
        }),

      nextSlide: () => {
        const { currentIndex, files } = get();
        const nextIndex =
          currentIndex < files.length - 1 ? currentIndex + 1 : 0;
        set({ currentIndex: nextIndex });
      },

      prevSlide: () => {
        const { currentIndex, files } = get();
        const prevIndex =
          currentIndex > 0 ? currentIndex - 1 : files.length - 1;
        set({ currentIndex: prevIndex });
      },
    },
  }),
);
